import React, { useState } from "react";
import {
  Box,
  Text,
  Grid,
  GridItem,
  Accordion,
  AccordionPanel,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  Spacer,
  UnorderedList,
  ListItem,
  Button,
  Flex,
  Link,
} from "@chakra-ui/react";
import { ReactComponent as LearningPlan } from "../../img/learningPlan.svg";

interface Subject {
  subject: string;
  pass_form?: string;
  passForm?: string;
  options?: Subject[];
}

interface Semester {
  term_number: number;
  subjects: Subject[];
}

const Plan = ({ plan, color, profileId }: { plan: Semester[]; color: string, profileId: number }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box>
      <Flex>
        <Text as="b" fontSize="26px">
          Учебный план
        </Text>
          {/* <Link href={`/lk/diplomas_view/${profileId}`} isExternal>
        <Button ml={'5'}>Проект диплома</Button>
        </Link> */}
      </Flex>
      <Grid
        mt="20px"
        gap="20px"
        fontSize="16px"
        templateColumns={{
          base: "1fr",
          md: "repeat(2, 1fr)",
          xl: "repeat(4, 1fr)",
        }}
        maxHeight={isOpen ? "none" : "400px"}
        pb={isOpen ? "60px" : "0"}
        overflow="hidden"
        position="relative"
        // templateRows={['repeat(4, 1fr)', 'repeat(2, 1fr)', '1fr']}
      >
        {plan
          .sort((a: Semester, b: Semester) => a.term_number - b.term_number)
          .map((sem) => (
            <GridItem>
              <Box p="20px" bg="gray.200" h="100%" borderRadius="10px">
                <Box>
                  <Text as="b" fontSize="24px">
                    {sem.term_number} семестр
                  </Text>
                </Box>
                <Accordion allowMultiple>
                  {sem.subjects.map((subj: Subject) =>
                    subj.hasOwnProperty("options") ? (
                      <AccordionItem bg="white" mt="10px" borderRadius="7px">
                        <AccordionButton p="15px 20px">
                          <Box textAlign="left">
                            <Box fontSize="18px">{subj.subject}</Box>
                            <Box color="#989B8D">
                              {subj.pass_form || subj.passForm}
                            </Box>
                          </Box>
                          <Spacer />
                          <AccordionIcon color={color} />
                        </AccordionButton>
                        <AccordionPanel>
                          <UnorderedList
                            p="15px 20px"
                            borderTop="2px dashed #989B8D"
                          >
                            {subj.options?.map((option: Subject) => (
                              <ListItem>{option.subject}</ListItem>
                            ))}
                          </UnorderedList>
                        </AccordionPanel>
                      </AccordionItem>
                    ) : (
                      <AccordionItem bg="white" mt="10px" borderRadius="7px">
                        <Box p="15px 20px">
                          <Box fontSize="18px">{subj.subject}</Box>
                          <Box color="#989B8D">
                            {subj.pass_form || subj.passForm}
                          </Box>
                        </Box>
                      </AccordionItem>
                    )
                  )}
                </Accordion>
                {!isOpen && (
                  <Box
                    position="absolute"
                    bottom="0"
                    left="0"
                    right="0"
                    height="100px"
                    background="linear-gradient(to top, white, transparent)"
                  />
                )}
              </Box>
            </GridItem>
          ))}
        <Button
          onClick={toggleOpen}
          position="absolute"
          bottom="0"
          left="50%"
          transform="translateX(-50%)"
        >
          {isOpen ? "Скрыть" : "Показать все"}
        </Button>
      </Grid>
    </Box>
  );
};
export default Plan;
